export default __webpack_public_path__ + "static/media/671a864c2c9f04f7cdf0f33296a5b55a.svg";